import React from "react";
import { StarIcon, QuoteIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { SectionHeading } from "./SectionHeading";
import { testimonials } from "../data/content";
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-322" data-mp="3fy2whny8ddzt">
      <div className="mx-auto max-w-5xl" data-id="element-323" data-mp="3b1clhf1a98l9">
        <SectionHeading eyebrow="What professionals are saying" title="Nutrition professionals who now work with a clear structure" data-id="element-324" data-mp="3b0ayqdawmxnp" />

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-325" data-mp="31yuxav22i5vm">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl bg-white p-5 shadow-[0_6px_24px_-14px_rgba(11,31,58,0.3)] sm:p-7" data-id="element-326" data-mp="2x007va9lhj2j">
              <div className="flex items-center gap-4" data-id="element-327" data-mp="2s3jk4h6b56pz">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold sm:h-[72px] sm:w-[72px]" loading="lazy" data-id="element-328" data-mp="v9oq3o1x3o4k" />
                <div className="min-w-0" data-id="element-329" data-mp="h8145e8mjyfq">
                  <figcaption className="text-[17px] font-bold text-navy" data-id="element-330" data-mp="m5b4hoxjxuic">{t.name}</figcaption>
                  <p className="text-sm text-muted" data-id="element-331" data-mp="78aepqyx89mi">{t.role}</p>
                  <p className="text-sm text-muted" data-id="element-332" data-mp="7a4wwxit5nmw">{t.location}</p>
                </div>
              </div>
              <div className="mt-4 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-333" data-mp="zwfwc4uohii4">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-334" data-mp="14uhgkt3ubnv6" data-mpi={i} />)}
              </div>
              <blockquote className="relative mt-3 text-[16px] leading-relaxed text-ink" data-id="element-335" data-mp="q4jy8tsldsdw">
                <QuoteIcon className="mb-1 h-5 w-5 text-gold/60" aria-hidden="true" data-id="element-336" data-mp="v3wkpdfjwxfy" />
                {t.quote}
              </blockquote>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-337" data-mp="1nmsdm6btcrld">
          <CTAButton label="I want to organize my consultations like them" note="One-Time Payment of $27 USD · Instant Download · 7-Day Money-Back Guarantee" data-id="element-338" data-mp="1nnv44d584s0r" />
        </div>
      </div>
    </section>;
}